import { Typography } from '@rossum/ui/material';
import createDOMPurify from 'dompurify';
import { sanitizeLinks } from '../../../../lib/htmlSanitization';

const DOMPurify = createDOMPurify();

DOMPurify.addHook('afterSanitizeAttributes', node => {
  sanitizeLinks(node);

  // TODO: We can remove this later when B/E is released
  if (node instanceof HTMLElement && node.hasAttribute('style')) {
    // Allowing style attribute can be risky, we want to allow only color in the style

    const allowedCSSProperties = ['color'];
    const styles = node.style.cssText.split(';').filter(style => {
      const [property] = style.split(':').map(s => s.trim());
      return property && allowedCSSProperties.includes(property);
    });

    node.setAttribute('style', styles.join(';'));
  }
});

export const Summary = ({ content }: { content: string }) => {
  // You can use this to have a test response from backend.
  // const content =
  //   'Trigger when <span class="field">Amount Due</span> is greater than <span class="value">1000</span>, using default value of <span class="value">0</span> if field is missing';

  return (
    <Typography
      variant="body2"
      color="text.primary"
      sx={{
        '.field': { fontWeight: 'bold' },
        '.value': { fontWeight: 'bold' },
      }}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content, {
          // `strong` / `style` can go away but we might need to be compatible with previous backend.
          ALLOWED_TAGS: ['span', 'strong'],
          ALLOWED_ATTR: ['style', 'class'],
        }),
      }}
    />
  );
};
